import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        paper: {
            width: '80%',
            maxWidth: `${theme.spacing(100)} !important`,
        },
        title: {
            '&&': {
                background: theme.palette.primary[600],
                color: theme.palette.common.white,
                padding: theme.spacing(1, 1.5),
                fontSize: theme.typography.h5.fontSize,
            },
        },
        dialogContent: {
            padding: `${theme.spacing(1.5, 2.5)} !important`,
            overflow: 'hidden !important',
        },
    }
})

export default useStyles
